module.exports = __webpack_public_path__ + "img/chevron-double-right.203076ff.svg";